import { validarUrlOpcional } from './auxiliares';
import { useMetadadosItem } from './useMetadadosItem';

export const useMetadadosBreadcrumbs = () => {
  const criterios = [
    {
      texto: 'O breadcrumb deve conter o hostname do permalink e http(s)',
      otimizado: false,
    },
  ];

  function validacoes(index, permalink, breadcrumbs) {
    switch (index) {
      case 0:
        return validarUrlOpcional(permalink, breadcrumbs);
    }
  }

  return useMetadadosItem({ itemCriterios: criterios, validacoesFn: validacoes });
};
